import React from "react";
import { motion } from "framer-motion";
import "./About.css";
import Slider from "react-slick";

export default function About() {
  const testimonials = [
    {
      name: "Heena Vibhakar",
      role: "Home Owner",
      icon: "👩",
      text: "Very good service very much impressed with work and constant follow up for service keep growing all the best."
    },
    {
      name: "Zurya Rd",
      role: "Apartment Owner",
      icon: "👨",
      text: "Good job , vijay was dedicated person Honest , respectful person"
    },
    {
      name: "Padmapriya J",
      role: "Interior Client",
      icon: "👩",
      text: "Excellent work! Keep up the fantastic performance! Great job done by your team! Your attention to detail and innovative approach really made a difference. Well done!"
    },
    {
      name: "Dr Devdutt Thomas",
      role: "Home Owner",
      icon: "👨",
      text: "Excellent and prompt service , will always recommend 👍👍"
    },
    {
      name: "Abdul Salam A",
      role: "Villa Owner",
      icon: "👨",
      text: "Good quality of mosquito nets with great customer service support and responsible in their work"
    },
    {
      name: "Princy D",
      role: "Flat Owner",
      icon: "👩",
      text: "Very good service excellencet product, good communication"
    }
  ];

  const settings = {
    centerMode: true,
    infinite: true,
    centerPadding: "0px",
    slidesToShow: 3,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 800,
    arrows: false,
    dots: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerMode: false
        }
      }
    ]
  };
  return (
    <div className="about-page">

      {/* ===== ABOUT HERO SECTION ===== */}
      <section className="about-hero">
        <div className="about-hero-overlay">
          <motion.div
            className="about-hero-content"
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, ease: "easeOut" }}
          >
            <h1>About Us</h1>
            <p>
              Crafting Elegant & Comfortable Interior Spaces in Coimbatore
            </p>
          </motion.div>
        </div>
      </section>

      {/* ===== ABOUT COMPANY SECTION ===== */}
      <section className="about-company">
        <div className="about-company-container">

          {/* LEFT CONTENT */}
          <div className="about-company-content">
            <span className="about-tag">Who We Are</span>
            <h2>
              Premium Interior Designers in Coimbatore
            </h2>

            <p>
              <strong>The Blessing Interiors</strong> is a professional interior décor
              brand based in Coimbatore, dedicated to designing elegant, functional,
              and comfortable living spaces. Established in 2025, we focus on modern
              interior solutions that blend aesthetics with everyday practicality.
            </p>

            <p>
              We specialize in <strong>custom curtains, modern blinds, luxury
                wallpapers, sofa fabrics, and Netlon mosquito mesh installation</strong>
              for residential and commercial spaces. Each project is approached with
              attention to detail, quality materials, and personalized styling.
            </p>

            <p>
              Our goal is to help homeowners and businesses transform their interiors
              into spaces that feel warm, refined, and long-lasting — without
              unnecessary complexity or inflated costs.
            </p>
          </div>

          {/* RIGHT IMAGES */}
          <div className="about-company-images">
            <img
              src="/images/sofa.jpg"
              alt="Interior Design Company in Coimbatore"
              className="img-large"
            />
            <img
              src="/images/sofa.jpg"
              alt="Modern Home Interior Design"
              className="img-small"
            />
          </div>

        </div>
      </section>

      {/* ===== VISION & MISSION SECTION ===== */}
      {/* ===== VISION & MISSION SECTION ===== */}
      <section className="vision-mission">
        <div className="vision-mission-container">

          {/* ===== VISION (LEFT CARD) ===== */}
          <div className="vm-card">
            <div className="vm-icon">
              <span>👁️</span>
            </div>

            <div className="vm-content">
              <h3>Our Vision</h3>
              <p>
                To become a trusted interior décor brand in Coimbatore, known for
                creating elegant, comfortable, and timeless living spaces that enhance
                everyday life.
              </p>
            </div>
          </div>

          {/* ===== MISSION (RIGHT CARD) ===== */}
          <div className="vm-card">
            <div className="vm-icon">
              <span>🎯</span>
            </div>

            <div className="vm-content">
              <h3>Our Mission</h3>
              <p>
                To deliver premium interior décor solutions using quality materials,
                thoughtful design, and professional execution — ensuring customer
                satisfaction at every stage.
              </p>
            </div>
          </div>

        </div>
      </section>


      {/* ===== WHAT WE DO : ICON BULLET DESIGN ===== */}
      <section className="what-we-do">
        <div className="what-container">

          <div className="what-heading">
            <span className="section-tag">Our Services</span>
            <h2>What We Do</h2>
            <p>
              We provide specialized interior décor solutions designed to enhance
              comfort, style, and functionality for homes and offices.
            </p>
          </div>

          <div className="what-list">
            <div className="what-item">
              <span className="what-icon">🪟</span>
              <div>
                <h4>Custom Curtains & Drapes</h4>
                <p>Tailor-made curtains designed to suit your space and lifestyle.</p>
              </div>
            </div>

            <div className="what-item">
              <span className="what-icon">🪟</span>
              <div>
                <h4>Modern Blinds Solutions</h4>
                <p>Roller, zebra, wooden, and vertical blinds for modern interiors.</p>
              </div>
            </div>

            <div className="what-item">
              <span className="what-icon">🖼️</span>
              <div>
                <h4>Luxury Wallpapers</h4>
                <p>Premium wallpapers that elevate walls with texture and elegance.</p>
              </div>
            </div>

            <div className="what-item">
              <span className="what-icon">🛋️</span>
              <div>
                <h4>Sofa Fabrics & Upholstery</h4>
                <p>High-quality fabrics to refresh and restore your furniture.</p>
              </div>
            </div>

            <div className="what-item">
              <span className="what-icon">🦟</span>
              <div>
                <h4>Netlon Mosquito Mesh</h4>
                <p>Durable mesh installation for doors and windows.</p>
              </div>
            </div>
          </div>

        </div>
      </section>

      {/* ===== WHY CHOOSE US ===== */}
      <section className="why-choose-us">
        <div className="why-container">

          <div className="why-heading">
            <h2>Why Choose The Blessing Interiors</h2>
            <p>
              We focus on quality, transparency, and long-term satisfaction — not
              shortcuts or copy-paste designs.
            </p>
          </div>

          <div className="why-grid">

            <div className="why-card">
              <div className="why-icon">⭐</div>
              <h4>Premium Quality Materials</h4>
              <p>
                We use carefully selected fabrics, fittings, and materials that
                ensure durability, comfort, and elegant finish.
              </p>
            </div>

            <div className="why-card">
              <div className="why-icon">🎯</div>
              <h4>Personalized Design Approach</h4>
              <p>
                Every interior is designed based on your lifestyle, space usage,
                and preferences — no generic solutions.
              </p>
            </div>

            <div className="why-card">
              <div className="why-icon">🤝</div>
              <h4>Honest Consultation</h4>
              <p>
                Transparent pricing, clear guidance, and genuine recommendations
                from start to finish.
              </p>
            </div>

            <div className="why-card">
              <div className="why-icon">🛠️</div>
              <h4>Professional Installation</h4>
              <p>
                Experienced team ensures precise measurement, clean execution,
                and neat finishing.
              </p>
            </div>

          </div>

        </div>
      </section>

      <section className="testimonials">
        <div className="testimonials-container">

          <div className="testimonials-heading center">
            <span className="section-tag light">Testimonials</span>
            <h2>What Our Clients Say</h2>
            <p>Real experiences from customers who trusted us</p>
          </div>

          <Slider {...settings} className="testimonial-slider">

            {testimonials.map((item, index) => (
              <div key={index} className="testimonial-slide">
                <div className="testimonial-card">
                  <div className="testimonial-avatar">{item.icon}</div>
                  <p>{item.text}</p>
                  <h4>{item.name}</h4>
                  <span>{item.role}</span>
                </div>
              </div>
            ))}

          </Slider>

        </div>
      </section>
    </div>
  );
}
